exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2GtjNZr_QAmjA7Ppzb8Ffh{font-size:16px;height:16px;line-height:31px;width:16px;color:\"[theme:neutralSecondary, default:#666666]\"!important}html[dir=ltr] ._2GtjNZr_QAmjA7Ppzb8Ffh{margin-left:16px;margin-right:12px}html[dir=rtl] ._2GtjNZr_QAmjA7Ppzb8Ffh{margin-right:16px;margin-left:12px}html[dir] .oDmlODyB9rU3skP9q627S{padding-bottom:16px}html[dir] ._3DK98xzwCp8B30u6WN3xB2{padding-bottom:14px}html[dir] .j7sQDXp_rCBknbptpOb_Z{padding-bottom:16px}", ""]);
// Exports
exports.locals = {
	"iconRoot": "_2GtjNZr_QAmjA7Ppzb8Ffh",
	"iconRootComputer": "oDmlODyB9rU3skP9q627S",
	"iconRootCloud": "_3DK98xzwCp8B30u6WN3xB2",
	"iconRootUploadAndShare": "j7sQDXp_rCBknbptpOb_Z"
};